/* jshint esversion: 6 */
import * as constants from 'app/redux/constants.js';
import { defaultState } from 'app/redux/defaultState.js';

export const modals = (state = defaultState.modals, action) => {
    // don't deep clone modal state since it'll send the interpreter into
    // an infinite loop
    let nextState = Object.assign({}, state);

    switch (action.type) {
        case constants.MODAL_ADD:
            nextState.stack.push(action.modal);
            break;

        case constants.MODAL_CLOSE:
            let nextModals = [];
            for (let i = 0; i < nextState.stack.length; ++i) {
                if (nextState.stack[i] !== action.modal) {
                    nextModals.stack.push(nextState.stack[i]);
                }
            }
            nextState.stack = nextModals;
            break;

        case constants.MODAL_CLOSE_ALL:
            nextState.stack = [];
            break;

        case constants.MODAL_CLOSE_OTHERS:
            nextState.stack = [action.modal];
            break;

        case constants.MODAL_POP:
            nextState.stack.pop();
            break;

        default:
            break;

    }

    return nextState;
};
